export enum UrlsEnum  {
  ROOT = "/",
  LOGIN = "/login",
  TRANSACTION_CREATE = "/transaction/create",
  TRANSACTION_RESTORE = "/transaction/restore",
  TRANSACTION_COMPLETE = "/transaction/complete"
}